<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Shop Management' }}</span>
</div>
<form [formGroup]="filterFormGroup" class="list-work-order-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Shop Management</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-shop-management-search
        class="search-bar"
        [workOrderSearchTextForm]="filterFormGroup.controls.workOrderSearchTextForm"></app-shop-management-search>
    </div>
  </div>

  <app-shop-management-filters [filterFormGroup]="filterFormGroup"></app-shop-management-filters>
  <app-shop-management-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-shop-management-grid>
</form>
